import {useNavigate} from 'react-router-dom';
import { useAuth } from '../auth/AppAuthProvider';
import {
  AuthProvider,
  SignInPage,
} from '@toolpad/core/SignInPage';
import axios from '../api/axios';

const providers = [{ id: 'credentials', name: 'Email and Password' }];

interface AuthResponse {
  token: string;
}

export default function LoginPage() {
  const navigate = useNavigate();
  const authContext = useAuth();

  const signIn: (provider: AuthProvider, formData: FormData) => void = async (
    provider,
    formData,
  ) => {
    const username = formData.get('email') as string;
    const password = formData.get('password') as string;

    try {
      const response = await axios.post<AuthResponse>('/auth/login', { username, password });

      authContext.login(response.data.token);
      localStorage.setItem('token', response.data.token);

      navigate('/');
    } catch (e) {
      return({
        type: 'CredentialsSignin',
        error: 'Invalid credentials.',
      });
    }
  };

  return (
    <SignInPage
      signIn={signIn}
      providers={providers}
      slotProps={{ emailField: { autoFocus: false }, form: { noValidate: true } }}
    />
  );
}
